import React, { useContext } from 'react';
import EditView from './EditView';
import ShowView from './ShowView';
import { FilterDetailStateContext } from '../index';
import { useParams } from 'react-router-dom';

const DetailView = () => {
    const { filterNum } = useParams();
    const { editMode } = useContext(FilterDetailStateContext);
    return !filterNum || editMode ? <EditView /> : <ShowView />;
};

export default DetailView;
